import { useEffect, useMemo, useState } from 'react';

import { FiMapPin, FiEdit3 } from 'react-icons/fi';
import { useFormContext } from 'react-hook-form';

import AutoComplete from '@components/AutoComplete';
import Input from '@components/Input';

import { FieldRendererProps } from '../types';

const CityField = ({ field, disabled }: FieldRendererProps) => {
  const { watch, setValue } = useFormContext();
  const [isInputOtherVisible, setIsInputOtherVisible] = useState(false);

  const dependsOn = field.depends_on;

  const depsMap = useMemo(() => {
    if (!dependsOn) return { uf: 'estado' };
    if (typeof dependsOn === 'string') return { uf: dependsOn };
    return dependsOn;
  }, [dependsOn]);

  const depFieldNames = Object.values(depsMap);
  const depValues = watch(depFieldNames);

  const params = useMemo(() => {
    const result: { name: string; value: string }[] = [];
    const paramKeys = Object.keys(depsMap);

    paramKeys.forEach((paramKey, index) => {
      const val = depValues[index];
      if (val) {
        result.push({ name: paramKey, value: val });
      }
    });

    return result;
  }, [depsMap, depValues]);

  const allDepsFilled = depValues.every((v: unknown) => !!v);

  useEffect(() => {
    setValue(field.name, '');
    setIsInputOtherVisible(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(depValues)]);

  // Nome do campo auxiliar para o texto livre
  const otherFieldName = `${field.name}_other`;

  useEffect(() => {
    if (!isInputOtherVisible) {
      setValue(otherFieldName, '');
    }
  }, [isInputOtherVisible, otherFieldName, setValue]);

  return (
    <div>
      {!isInputOtherVisible && (
        <AutoComplete
          name={field.name}
          placeholder={field.placeholder || 'Digite para buscar...'}
          icon={FiMapPin}
          disabled={disabled || !allDepsFilled}
          required={field.is_required}
          url={field.autocomplete_url || '/utils/cities'}
          params={params}
          setIsInputOtherVisible={setIsInputOtherVisible}
        />
      )}

      {isInputOtherVisible && (
        <div style={{ marginTop: isInputOtherVisible ? 0 : 8 }}>
          <Input
            name={otherFieldName}
            placeholder="Digite o nome"
            icon={FiEdit3}
            required={field.is_required}
          />
          <button
            type="button"
            onClick={() => {
              setIsInputOtherVisible(false);
              setValue(otherFieldName, '');
              setValue(field.name, '');
            }}
            style={{
              background: 'none',
              border: 'none',
              color: '#556ee6',
              fontSize: '0.8rem',
              cursor: 'pointer',
              padding: '4px 0',
            }}
          >
            Voltar para busca na lista
          </button>
        </div>
      )}
    </div>
  );
};

export default CityField;
